export default "__VITE_ASSET__a0ebc1be__"